import { useState } from "react";
import MUITable, {
  TableHeader,
} from "../../../../../../common/components/mui-table/mui-table";
import "./user-dashboard-milestone-list.scss";
import DeleteConfirmationPopup from "../../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import CompanyDashboardInitiativeDrawerAddMilestones from "../../../../../company-dashboard/company-dashboard-initiative/company-dashboard-initiative-add-drawer/company-dashboard-initiative-drawer-milestones/company-dashboard-initiative-drawer-add-milestones/company-dashboard-initiative-drawer-add-milestones";

/**
 * UserDashboardMilestoneList
 *
 * Milestone table for the User Dashboard drawer. Adds a small transformer to accept
 * departments list from varying API shapes and pass a normalized list to MUITable filters.
 *
 * Expected props:
 * - data, onRowClick: forwarded to MUITable
 * - selectedMilestone, setSelectedMilestone: selection state (any)
 * - departmentsList: Array<{ pk?, key?, departmentName?, value? }>
 */
const headers: TableHeader[] = [
  { key: "title", label: "Title" },
  { key: "assignedTo", label: "Assigned To" },
  { key: "department", label: "Department", filterable: true },
  { key: "date", label: "Date" },
  { key: "status", label: "Status" },
];
const UserDashboardMilestoneList: any = (props: any) => {
  const { onRowClick, data, departmentsList } = props;

  // Transform departments list from API format to MUITable expected format
  const transformedDepartmentsList =
    departmentsList?.map((dept: any) => ({
      key: dept.pk || dept.key, // Support both pk (from API) and key (existing format)
      value: dept.departmentName || dept.value, // Support both departmentName (from API) and value (existing format)
    })) || [];

  const [addPopupTitle] = useState<string>("");
  const [isOpenAddPopup] = useState(false);
  const [isDeletePopupOpenMilestone, setIsDeletePopupOpenMilestone] =
    useState(false);
  const [deletePopupIdMilestone, setDeletePopupIdMilestone] =
    useState<any>(null);

  const handleDeleteMilestone = async (deletePopupIdMilestone: any) => {
    if (!deletePopupIdMilestone) return;
    try {
      setIsDeletePopupOpenMilestone(false);
      setDeletePopupIdMilestone(null);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <div className="user-dashboard-milestone-list-content">
        <MUITable
          columnNames={headers}
          rowsData={data}
          onRowClick={onRowClick}
          departmentsList={transformedDepartmentsList}
          noRecordsTitle={"Please reload the page, or add new data."}
          noRecordsMessage={"Quiet zone! Nothing’s landed here for you yet."}
        />
      </div>
      <CompanyDashboardInitiativeDrawerAddMilestones
        isOpenAddPopup={isOpenAddPopup}
        onCancel={() => {}}
        addPopupTitle={addPopupTitle}
      />
      {isDeletePopupOpenMilestone && (
        <DeleteConfirmationPopup
          isOpen={true}
          onClose={() => {
            setIsDeletePopupOpenMilestone(false);
            setDeletePopupIdMilestone(null);
          }}
          handleDelete={() => {
            handleDeleteMilestone(deletePopupIdMilestone);
            setIsDeletePopupOpenMilestone(false);
          }}
          deleteId={deletePopupIdMilestone}
        />
      )}
    </>
  );
};
export default UserDashboardMilestoneList;
